import { createFileRoute } from "@tanstack/react-router";
import MedicalStudyGuideFr from "@/pages/resources/fr/MedicalStudyGuideFr";

export const Route = createFileRoute("/fr/learn/medical-study-ai")({
  head: () => ({
    meta: [
        {
            "title": "Réviser le PASS avec l'IA : le guide complet | System Atlas"
        },
        {
            "name": "description",
            "content": "Comment utiliser les outils IA pour réviser la PASS/médecine. Stratégies par matière, plannings d'étude et techniques de rétention prouvées."
        },
        {
            "property": "og:title",
            "content": "Réviser le PASS avec l'IA : le guide complet | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Comment utiliser les outils IA pour réviser la PASS/médecine. Stratégies par matière, plannings d'étude et techniques de rétention prouvées."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/medical-study-ai"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Réviser le PASS avec l'IA : le guide complet | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Comment utiliser les outils IA pour réviser la PASS/médecine. Stratégies par matière, plannings d'étude et techniques de rétention prouvées."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/medical-study-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/medical-study-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/medical-study-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/medical-study-ai"
        }
    ],
  }),
  component: MedicalStudyGuideFr,
});
